/**
 * Los avisos de una importación del Excel de riesgos (`data.warnings` de la respuesta), listos para mostrarse: sin el
 * prefijo de bitácora del API y sin repetidos. La importación ya se guardó; los avisos dicen qué no se pudo leer o qué
 * se ignoró (una hoja «Flujo - OS2» sin cuentas, la fila «Renta mensual» que falta, un balance descuadrado).
 */
export function riskImportWarnings(response: { data?: { warnings?: unknown } } | null | undefined): string[] {
  const raw = response?.data?.warnings
  if (!Array.isArray(raw)) return []
  const clean = raw.filter((w): w is string => typeof w === 'string').map((w) => w.replace(/^\[RISK-IMPORT-WARN\]\s*/, '').trim())
  return [...new Set(clean.filter((w) => w !== ''))]
}
